/**
 * Collection PLP vehicle bar:
 * - No garage vehicle → show Year/Make/Model picker (#cm-ymm)
 * - Vehicle selected → Best Fit sort, show vehicle title, allow clear (all products)
 */
(function () {
  var ROOT_SEL = '[data-fcd-collection-vehicle]';
  var BEST_FIT_SORT = 'relevance';
  var syncedSortForVehicle = false;

  function cm() {
    return window.Convermax || null;
  }

  function isSelected() {
    var api = cm();
    if (!api) return false;
    if (typeof api.isVehicleSelected === 'function') {
      try {
        return !!api.isVehicleSelected();
      } catch (e) {
        /* fall through */
      }
    }
    if (typeof api.getVehicleString === 'function') {
      try {
        return String(api.getVehicleString() || '').trim().length > 0;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  function vehicleTitle() {
    var api = cm();
    if (!api || typeof api.getVehicleString !== 'function') return '';
    try {
      return String(api.getVehicleString() || '').trim();
    } catch (e) {
      return '';
    }
  }

  function setBestFitSort() {
    var api = cm();
    if (!api || typeof api.setSearchSort !== 'function') return;
    try {
      var current =
        typeof api.getSearchSort === 'function' ? api.getSearchSort() : null;
      if (current === BEST_FIT_SORT) {
        syncedSortForVehicle = true;
        return;
      }
      api.setSearchSort(BEST_FIT_SORT);
      syncedSortForVehicle = true;
    } catch (e) {
      /* Convermax may not be ready yet */
    }
  }

  function syncUi() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;

    var selected = isSelected();
    var title = vehicleTitle();
    var titleEl = root.querySelector('[data-fcd-vehicle-title]');
    var mobileText = document.querySelector('.mobile-vehicle-bar__text');

    root.setAttribute('data-state', selected ? 'selected' : 'empty');
    document.body.classList.toggle('fcd-collection-has-vehicle', selected);

    if (titleEl) titleEl.textContent = title || 'Your Vehicle';

    if (mobileText) {
      var fallback =
        mobileText.getAttribute('data-default-label') || 'Select Your Vehicle';
      mobileText.textContent = selected ? title || 'Your Vehicle' : fallback;
    }

    if (selected) setBestFitSort();
  }

  function discardVehicle() {
    var api = cm();
    if (!api || typeof api.discardVehicle !== 'function') return;
    try {
      api.discardVehicle();
    } catch (e) {
      return;
    }
    syncedSortForVehicle = false;
    syncUi();
  }

  function bindClear() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    var btn = root.querySelector('[data-fcd-vehicle-clear]');
    if (!btn || btn.dataset.fcdBound === '1') return;
    btn.dataset.fcdBound = '1';
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      discardVehicle();
    });
  }

  function rememberMobileDefaultLabel() {
    var mobileText = document.querySelector('.mobile-vehicle-bar__text');
    if (mobileText && !mobileText.getAttribute('data-default-label')) {
      mobileText.setAttribute(
        'data-default-label',
        mobileText.textContent.trim()
      );
    }
  }

  function chainHook(name, handler) {
    window.Convermax = window.Convermax || {};
    var prev = window.Convermax[name];
    window.Convermax[name] = function () {
      var args = arguments;
      try {
        if (typeof prev === 'function') prev.apply(window.Convermax, args);
      } catch (e) {
        /* keep going */
      }
      handler.apply(null, args);
    };
  }

  function start() {
    rememberMobileDefaultLabel();
    bindClear();
    syncUi();

    chainHook('onVehicleSelected', function () {
      syncUi();
    });
    chainHook('onVehicleRemoved', function () {
      syncUi();
    });

    // Convermax often hydrates after our script; poll briefly then settle.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      syncUi();
      if (tries > 40) window.clearInterval(timer);
    }, 250);

    document.addEventListener('cm:ready', syncUi);
    document.addEventListener('convermax:ready', syncUi);
    window.addEventListener('cm:results', syncUi);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
